// var cs_url_param_str = decodeURIComponent(location.search);
var cs_url_param_raw_arr = location.search.split("?");
var cs_variants = [];
var cs_title = "";
var cs_image = "";
if (cs_url_param_raw_arr.length > 1) {
  var cs_url_param_arr = cs_url_param_raw_arr[1].split("&");
  if (cs_url_param_arr.length > 0) {
    for (i in cs_url_param_arr) {
      let param = decodeURIComponent(cs_url_param_arr[i]).split("=");
      let variation = param;
      if (param.length > 1) {
        if (param[0] == "title") {
          cs_title = param[1];
          $(".cst-product").text(cs_title);
        }
        if (param[0] == "image") {
          cs_image = param[1];
          $(".cst-image img").attr("src", cs_image);
        }
        // console.log(param);
        //variation[0] = 'child_0';
        if (
          param[0] == "child_0" ||
          param[0] == "child_1" ||
          param[0] == "child_2" ||
          param[0] == "child_3" ||
          param[0] == "child_4" ||
          param[0] == "child_5" ||
          param[0] == "child_6" ||
          param[0] == "child_7" ||
          param[0] == "child_8" ||
          param[0] == "child_9" ||
          param[0] == "child_10"
        ) {
          let str_clean = param[1].replace(/\s/g, "");
          let str_parse = JSON.parse(str_clean);
          let child_html = `${str_parse.title} x ${str_parse.quantity}`;

          //console.log(child_html);
          cs_variants.push(child_html);

          ///console.log(cs_variants);

          //let child_obj = JSON.parse(param[0]);
          //let child_html = `${str_clean.quantity} x ${str_clean.title.replace( /\+/g, ' ' )}`;
          //console.log('child_html', child_html);
          //cs_variants.push(child_html);
        }

        // console.log("2");

        if (cs_title != "" && cs_image != "") {
          $(".cross-sell-top-notification span").show();
          $(".cst-image img").show();
          $(".cst-product").show();
        }
        if (cs_variants.length > 0) {
        }
      }
    }
    $(".cst-info").append(cs_variants.join(", "));
  }
}

$(document).ready(function () {
  // Cross Sell
  function CSCPIsElementInViewport(el) {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }

  $(".cs-close-popup, .cs-overlay").click(function () {
    $("html").toggleClass("cs-open");
  });

  function CSCPCheckVisibility() {
    var csc_accessories = $("#csc-accessories");
    var csc_products = $("#csc-products");

    if (CSCPIsElementInViewport(csc_accessories)) {
      $('span[data-url="csc-accessories"]').addClass("active").siblings().removeClass("active");
    } else {
      if (CSCPIsElementInViewport(csc_products)) {
        $('span[data-url="csc-products"]').addClass("active").siblings().removeClass("active");
      }
    }
  }

  function CSCPCalculatePopupTotal() {
    var total = 0;
    var total_bgn = 0;
    var total_compare_at_price = 0;
    var total_compare_at_price_bgn = 0;

    var product_id = $(".cs-popup").attr("product-id");

    $(".cs-popup-product-variants .cspp-variant.cspp-added").each(function () {
      var variant_id = $(this).attr("variant-id");
      var price = parseInt(cross_sell_products["sample"][product_id].variants[variant_id]["price"]);
      var price_bgn = parseInt(cross_sell_products["sample"][product_id].variants[variant_id]["price_bgn"]);
      var compare_at_price = parseInt(
        cross_sell_products["sample"][product_id].variants[variant_id]["compare_at_price"]
      );
      var compare_at_price_bgn = parseInt(
        cross_sell_products["sample"][product_id].variants[variant_id]["compare_at_price_bgn"]
      );
      console.log(price, "price");
      console.log(price_bgn, "price_bgn");
      console.log(compare_at_price, "compare_at_price");
      console.log(compare_at_price_bgn, "compare_at_price_bgn");

      total = total + price;
      total_bgn = total_bgn + price_bgn;
      total_compare_at_price = total_compare_at_price + compare_at_price;
      total_compare_at_price_bgn = total_compare_at_price_bgn + compare_at_price_bgn;
    });

    console.log(total, "total");
    console.log(total_bgn, "total_bgn");
    console.log(total_compare_at_price, "total_compare_at_price");
    console.log(total_compare_at_price_bgn, "total_compare_at_price_bgn");

    if (total == 0) {
      total = parseInt(cross_sell_products["sample"][product_id]["real_price"]);
    }

    if (total_bgn == 0) {
      total_bgn = parseInt(cross_sell_products["sample"][product_id]["real_price_bgn"]);
    }

    if (total_compare_at_price == 0) {
      total_compare_at_price = parseInt(cross_sell_products["sample"][product_id]["real_compare_at_price"]);
    }

    if (total_compare_at_price_bgn == 0) {
      total_compare_at_price_bgn = parseInt(
        cross_sell_products["sample"][product_id]["real_compare_at_price_bgn"]
      );
    }

     console.log(total, "total");
    console.log(total_bgn, "total_bgn");
    console.log(total_compare_at_price, "total_compare_at_price");
    console.log(total_compare_at_price_bgn, "total_compare_at_price_bgn");


    total = total / 100;
    total_bgn = total_bgn / 100;

    total_compare_at_price = total_compare_at_price / 100;
    total_compare_at_price_bgn = total_compare_at_price_bgn / 100;

    var floatPrice = parseFloat(total).toFixed(2);
    var floatPriceBgn = parseFloat(total_bgn).toFixed(2);
    var floatCompareAtPrice = parseFloat(total_compare_at_price).toFixed(2);
    var floatCompareAtPriceBgn = parseFloat(total_compare_at_price_bgn).toFixed(2);

    if (Shopify.theme_settings.show_euro_currency) {
      var PriceStr = `${cross_sell_symbol}${floatPrice}`;
      var PriceStrBgn = `${floatPriceBgn} лв.`;
      var PriceStrCompareAtPrice = `${cross_sell_symbol}${floatCompareAtPriceBgn}`;
      var PriceStrCompareAtPriceBgn = `${floatCompareAtPrice} лв.`;

      $(".csppb-left h3").text(PriceStr);
      $(".csppb-left h3").append(` / ${PriceStrBgn}`);

      $("span.dynamic-price.line-through").text(`${PriceStrCompareAtPrice} / ${PriceStrCompareAtPriceBgn}`);
    } else {
      // The € symbol goes before the number; other currencies (e.g. lei) after.
      var symbolFirst = cross_sell_symbol && cross_sell_symbol.trim() === "€";
      var PriceStr = symbolFirst
        ? `${cross_sell_symbol}${floatPrice}`
        : `${floatPrice} ${cross_sell_symbol}`;
      var PriceStrCompareAtPrice = symbolFirst
        ? `${cross_sell_symbol}${floatCompareAtPrice}`
        : `${floatCompareAtPrice} ${cross_sell_symbol}`;
      $(".csppb-left h3").text(PriceStr);
      $("span.dynamic-price.line-through").text(`${PriceStrCompareAtPrice}`);
    }
  }

  function CSCPPopupVariantTemplate(variant, product) {
    var id = variant.id;
    var name = variant.title;
    var image_src = variant.featured_image;
    var desciption = variant.description;
    var product_upsell = product.upsell;

    if (variant.variant.available) {
      return `
        <div class="cspp-variant" variant-id="${id}">
          <div class="csppv-left">
              <img src="${image_src}" />
          </div><!-- .csppv-left -->
          <div class="csppv-center">
              <h3>${name}</h3>
              <p>${desciption}</p>
              <h4>${product_upsell}</h4>
          </div><!-- .csppv-center -->
          <div class="csppv-right">
            <span>
              <svg class="cspp-remove-from-cart" width="17px" height="19px" viewBox="0 0 17 19" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Group" transform="translate(1.000000, 1.000000)" fill-rule="nonzero" stroke="#0B0B0B" stroke-width="2"><line x1="0" y1="3.333" x2="15" y2="3.333" id="Path"></line><path d="M13.333,3.333 L13.333,15 C13.333,15.92 12.587,16.667 11.667,16.667 L3.333,16.667 C2.413,16.667 1.667,15.92 1.667,15 L1.667,3.333" id="Path"></path><path d="M4.167,3.333 L4.167,1.667 C4.167,0.746 4.913,-1.50990331e-14 5.833,-1.50990331e-14 L9.167,-1.50990331e-14 C10.087,-1.50990331e-14 10.833,0.746 10.833,1.667 L10.833,3.333" id="Path"></path><line x1="5.833" y1="7.5" x2="5.833" y2="12.5" id="Path"></line><line x1="9.167" y1="7.5" x2="9.167" y2="12.5" id="Path"></line></g></g></svg>
              <svg class="cspp-add-to-cart" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g transform="translate(5.289 5.289)"><path d="M 13.422 6.711 C 13.422 6.303 13.091 5.972 12.683 5.972 L 7.45 5.972 L 7.45 0.739 C 7.45 0.331 7.119 0 6.711 0 C 6.303 0 5.972 0.331 5.972 0.739 L 5.972 5.972 L 0.739 5.972 C 0.331 5.972 0 6.303 0 6.711 C 0 7.119 0.331 7.45 0.739 7.45 L 5.972 7.45 L 5.972 12.683 C 5.972 12.887 6.055 13.072 6.188 13.206 C 6.4 13.417 6.718 13.481 6.994 13.366 C 7.27 13.252 7.45 12.982 7.45 12.683 L 7.45 7.45 L 12.683 7.45 C 13.091 7.45 13.422 7.119 13.422 6.711" fill="rgb(11, 11, 11)"></path></g></svg>
            </span>
          </div><!-- .csppv-right -->
        </div><!-- .cspp-variant -->
      `;
    }

    return "";
  }

  function CSCPPopupTemplate(product) {
    if (product.variants.length == 0) {
      return;
    }

    var txtclr = $(".cross-sell-content-bottom").attr("txtcolor");

    const hasEnabledEuroCurrency = Shopify.theme_settings.show_euro_currency;
    const hasDiscount = Number(product.real_compare_at_price) > 0;

    const priceRightHtml = hasEnabledEuroCurrency
      ? hasDiscount
        ? `
        <div class="csppim-right text-[18px] md:text-[20px] hidden md:block">
          <div class="flex flex-col text-left leading-[1.2]">
            <span class="line-through text-[18px] text-red-500">
              ${product.compare_at_price_bgn} / ${product.compare_at_price}
            </span>
            <span>${product.price_bgn} / ${product.price}</span>
          </div>
        </div>
        `
        : `
        <div class="csppim-right text-[18px] md:text-[20px] hidden md:block">${product.price} / ${product.price_bgn} </div>
        `
      : hasDiscount
      ? `
        <div class="csppim-right text-[18px] md:text-[20px] hidden md:block">
          <div class="flex flex-col text-left leading-[1.2]">
            <span class="line-through text-[18px] text-red-500">
              ${product.compare_at_price}
            </span>
            <span>${product.price}</span>
          </div>
        </div>
        `
      : `
        <div class="csppim-right text-[18px] md:text-[20px] hidden md:block">${product.price}</div>  
        `;

    const priceLeftHtml = hasEnabledEuroCurrency
      ? hasDiscount
        ? `
        <div class="csppb-left">
          <div class="flex flex-col leading-[1.2]">
            <span class="dynamic-price line-through text-[16px] md:text-[18px] text-red-500 font-[500]">
              ${product.compare_at_price} / ${product.compare_at_price_bgn}
            </span>
            <h3 class="text-[18px] md:text-[20px]">${product.price} / ${product.price_bgn}</h3>
          </div>
        </div>
        `
        : `
        <div class="csppb-left">
            <h3 class="text-[18px] md:text-[20px]">${product.price} / ${product.price_bgn}</h3>
            </div>
        `
      : hasDiscount
      ? `
        <div class="csppb-left">
          <div class="flex flex-col leading-[1.2]">
            <span class="dynamic-price line-through text-[18px] text-red-500">
              ${product.compare_at_price}
            </span>
            <h3 class="text-[18px] md:text-[20px]">${product.price}</h3>
          </div>
        </div>     
        `
      : `
        <div class="csppb-left">
          <h3 class="text-[18px] md:text-[20px]">${product.price}</h3>
        </div>     
        `;

    var product_info_template = `
      <div class="csppi-top">
        <div class="csppit-left" prdctimg="${product.featured_image}">
          <svg xmlns="http://www.w3.org/2000/svg" transform="translate(0 1)" width="10" height="10"><path d="M 5 0 L 6.469 2.977 L 9.755 3.455 L 7.378 5.773 L 7.939 9.045 L 5 7.5 L 2.061 9.045 L 2.622 5.773 L 0.245 3.455 L 3.531 2.977 Z" fill="var(--token-3791bf85-cb54-4151-b827-62f4d3706215, rgb(245, 133, 35))"></path></svg>
          ${product.callout}
        </div><!-- .csppit-left -->        
      </div><!-- .csppi-top -->
      <div class="csppi-middle">
  <div class="csppim-left">${product.title}<div class="csppit-right">
          ${product.upsell}
        </div><!-- .csppit-right -->	</div><!-- .csppim-left -->
        ${priceRightHtml}
      </div><!-- .csppi-middle -->
      <div class="csppi-bottom" style="color:${txtclr}">
        <p>${product.description}</p>
      </div><!-- .csppi-bottom -->`;
    var buttontext = $(".cross-sell-content-bottom").attr("btn-txt");

    var product_bottom_template = `${priceLeftHtml}
      
        <div class="csppb-right">
          <div class="disabled add-to-order">${buttontext}</div>
        </div><!-- .csppb-right -->`;

    var product_variants_html = "";

    for (i in product.variants) {
      product_variants_html += CSCPPopupVariantTemplate(product.variants[i], product);
    }

    var html = product_info_template;

    $(".cs-popup .cs-popup-content .cs-popup-product-info").empty();
    $(".cs-popup .cs-popup-content .cs-popup-product-variants").empty();
    $(".cs-popup .cs-popup-content .cs-popup-product-bottom").empty();

    $(".cs-popup .cs-popup-content .cs-popup-product-info").html(product_info_template);
    $(".cs-popup .cs-popup-content .cs-popup-product-variants").html(product_variants_html);
    $(".cs-popup .cs-popup-content .cs-popup-product-bottom").html(product_bottom_template);

    $(`.csc-product[product-id="${product.id}"] .cscpc-selected-variants .cscpc-selected-variant`).each(
      function () {
        var variant_id = $(this).attr("variant-id");
        if (variant_id != "") {
          if (
            $(`.cs-popup .cs-popup-product-variants .cspp-variant[variant-id="${variant_id}"]`) != undefined
          ) {
            $(`.cs-popup .cs-popup-product-variants .cspp-variant[variant-id="${variant_id}"]`).addClass(
              "cspp-added"
            );
          }
        }
      }
    );

    if (
      $(`.csc-product[product-id="${product.id}"] .cscpc-selected-variants .cscpc-selected-variant`).length >
      0
    ) {
      $(".cs-popup .csppb-right > div").removeClass("disabled");
    }

    return html;
  }

  $(window).scroll(function () {
    CSCPCheckVisibility();
  });

  CSCPCheckVisibility();

  $(".csc-sidebar-menu span").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    var id = $(this).data("url");
    if (id != "" && id != "#") {
      if ($("#" + id).length) {
        $("html, body").animate(
          {
            scrollTop: $("#" + id).offset().top - 400,
          },
          300
        );
      }
    }
  });

  $("#csc-products .csc-product .cscp-open-popup").click(function () {
    if (cross_sell_products == undefined) {
      //console.error('Cross Sell Products object is undefined');
      return;
    }

    var parent = $(this).parents(".csc-product");
    var product_id = parent.attr("product-id");

    if (product_id == "") {
      console.error("Product ID is undefined");
      return;
    }

    if (cross_sell_products["sample"][product_id] == undefined) {
      console.error("Product is undefined");
      return;
    }

    var template_html = CSCPPopupTemplate(cross_sell_products["sample"][product_id]);

    $(".cs-popup").attr("product-id", product_id);

    CSCPCalculatePopupTotal();

    $("html").toggleClass("cs-open");
  });

  $(document).on("click", ".cspp-variant .csppv-right span", function () {
    $(this).parents(".cspp-variant").toggleClass("cspp-added");
    if ($(".cs-popup .cs-popup-product-variants .cspp-variant.cspp-added").length > 0) {
      $(".cs-popup .csppb-right > div").removeClass("disabled");
    } else {
      $(".cs-popup .csppb-right > div").addClass("disabled");
    }

    CSCPCalculatePopupTotal();
  });

  // Custom Code START
  $(document).on("click", ".cs-popup .csppb-right > div", function () {
    if ($(this).hasClass("disabled")) {
      return;
    }

    var product_id = $(".cs-popup").attr("product-id");

    $(`.csc-product[product-id="${product_id}"] .cscpc-selected-variants`).empty();
    var items = [];
    $(".cs-popup .cs-popup-product-variants .cspp-variant.cspp-added").each(function () {
      var variant_id = $(this).attr("variant-id");
      // var title = $(this).find('.csppv-center h3').text();
      // var image = $(this).find('.csppv-left img').attr('src');

      var title = $(".addon-product-main").attr("static-txt");
      var image = $(".addon-product-main").attr("static-img");

      console.log(image);

      $("html").addClass("addon-popup");
      var successmsg = $(".cross-sell-content-bottom").attr("successmsg");
      $(".addon-product-main").html(
        "<div class='addon-product-popup'> <div class='addon-popup-inside'><div class='img'><img src=" +
          image +
          "></div> <h4>" +
          title +
          "</h4><span class='success'>" +
          successmsg +
          "</span></div></div>"
      );

      setTimeout(function () {
        $(".addon-product-main").html("");
        $("html").removeClass("addon-popup");
      }, 3000);

      //       var variant_html = `<div class="cscpc-selected-variant" variant-id="${variant_id}">
      //   <h4>${title}</h4>
      //                       <span>
      //                         <svg width="17px" height="19px" viewBox="0 0 17 19" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Group" transform="translate(1.000000, 1.000000)" fill-rule="nonzero" stroke="#0B0B0B" stroke-width="2"><line x1="0" y1="3.333" x2="15" y2="3.333" id="Path"></line><path d="M13.333,3.333 L13.333,15 C13.333,15.92 12.587,16.667 11.667,16.667 L3.333,16.667 C2.413,16.667 1.667,15.92 1.667,15 L1.667,3.333" id="Path"></path><path d="M4.167,3.333 L4.167,1.667 C4.167,0.746 4.913,-1.50990331e-14 5.833,-1.50990331e-14 L9.167,-1.50990331e-14 C10.087,-1.50990331e-14 10.833,0.746 10.833,1.667 L10.833,3.333" id="Path"></path><line x1="5.833" y1="7.5" x2="5.833" y2="12.5" id="Path"></line><line x1="9.167" y1="7.5" x2="9.167" y2="12.5" id="Path"></line></g></g></svg>
      //                       </span>
      //                     </div><!-- .cscpc-selected-variant -->`;

      // $('.cs-popup-product-variants').find('.cscpc-selected-variants .cscpc-selected-variant').each(function(){

      //   var variant_id = $(this).attr('variant-id');
      //   if(variant_id != ''){
      //     items.push({id: variant_id, quantity: 1});
      //   }

      // });
      items.push({ id: variant_id, quantity: 1 });

      //$(`.csc-product[product-id="${product_id}"] .cscpc-selected-variants`).append(variant_html);
    });
    if (items.length > 0) {
      //console.log('Items Data:' + items);
      //$(this).find('.button').addClass('loading');
      //var self = this;
    }
    jQuery.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/add.js",
      data: { items: items },
      dataType: "json",
      success: function (e) {
        setTimeout(function () {
          //$(".addon-product-main").html("");
          //$("html").removeClass('addon-popup');
          location = window.Shopify.routes.root + "cart";
        }, 1000);
      },
      error: function (e) {
        $(".cross-sell-content .notification .title").text(e.responseJSON.message);
        $(".cross-sell-content .notification .subtitle").text(e.responseJSON.description);
        // $('.cross-sell-content .notification').slideDown();
        // $(self).find('.button').removeClass('loading');
        // $(self).find('.button').addClass('loaded');
        // $('html, body').animate({
        //   scrollTop: 0
        // }, 300);
        setTimeout(function () {
          location = window.Shopify.routes.root + "cart";
        }, 1000);
      },
    });

    $("html").toggleClass("cs-open");

    //
  });
  // Custom Code END

  $(document).on("click", ".cscpc-selected-variant span", function () {
    $(this).parent().remove();
  });

  $(".cross-sell-top-button").click(function () {
    //console.log('clicked');
    var items = [];
    var popup_items = [];

    $("#csc-products .csc-product").each(function () {
      var product_id = $(this).attr("product-id");

      if (product_id == "") {
        return;
      }

      $(this)
        .find(".cscpc-selected-variants .cscpc-selected-variant")
        .each(function () {
          var variant_id = $(this).attr("variant-id");
          if (variant_id != "") {
            items.push({ id: variant_id, quantity: 1 });
          }
        });
    });

    $("#csc-accessories .csc-product.cspp-added").each(function () {
      var variant_id = $(this).attr("variant-id");

      if (variant_id == "") {
        return;
      }

      items.push({ id: variant_id, quantity: 1 });
    });

    if (items.length > 0) {
      $(this).find(".button").addClass("loading");
      var self = this;
      jQuery.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: { items: items },
        dataType: "json",
        success: function (e) {
          //$(".addon-product-main").html("<div class='addon-product-popup'> <div class='addon-popup-inside'><div class='img'><img src=" +e.items[0].image +"></div> <h4>" +e.items[0].handle + "</h4><span class='success'>Successfully added to basket</span></div></div>");

          //$("html").addClass('addon-popup');
          $(".cross-sell-content .notification .title").text("Products added to the cart");
          // $('.cross-sell-content .notification').slideDown();
          $(self).find(".button").removeClass("loading");
          $(self).find(".button").addClass("loaded");
          // $('html, body').animate({
          //   scrollTop: 0
          // }, 300);

          setTimeout(function () {
            //$(".addon-product-main").html("");
            //$("html").removeClass('addon-popup');
            location = window.Shopify.routes.root + "cart";
          }, 2000);
        },
        error: function (e) {
          $(".cross-sell-content .notification .title").text(e.responseJSON.message);
          $(".cross-sell-content .notification .subtitle").text(e.responseJSON.description);
          // $('.cross-sell-content .notification').slideDown();
          $(self).find(".button").removeClass("loading");
          $(self).find(".button").addClass("loaded");
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            300
          );
          setTimeout(function () {
            location = window.Shopify.routes.root + "cart";
          }, 500);
        },
      });
    } else {
      location = window.Shopify.routes.root + "cart";
    }
  });

  $("#csc-accessories .csc-product .cscp-open-popup").click(function () {
    var items = [];
    // var image = $(this).find('.prdct-img').attr('src');
    //var title = $('.cscp-center .cscpcm-left').text();
    // var title = $('#csc-accessories .csc-product').attr('prdct-title');
    // var image = $('#csc-accessories .csc-product').attr('prdct-img');

    var title = $(".addon-product-main").attr("static-txt");
    var image = $(".addon-product-main").attr("static-img");
    var variant_id = $("#csc-accessories .csc-product").attr("variant-id");
    //var variant_id = $(this).attr('variant-id');

    if (variant_id == "") {
      return;
    }

    items.push({ id: variant_id, quantity: 1 });

    //$(`.csc-product[product-id="${product_id}"] .cscpc-selected-variants`).append(variant_html);

    $("html").addClass("addon-popup");
    var successmsg = $(".cross-sell-content-bottom").attr("successmsg");
    $(".addon-product-main").html(
      "<div class='addon-product-popup'> <div class='addon-popup-inside'><div class='img'><img src=" +
        image +
        "></div> <h4>" +
        title +
        "</h4><span class='success'>" +
        successmsg +
        "</span></div></div>"
    );

    setTimeout(function () {
      $(".addon-product-main").html("");
      $("html").removeClass("addon-popup");
    }, 3000);

    if (items.length > 0) {
      console.log("Items Data:" + items);
    }
    jQuery.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/add.js",
      data: { items: items },
      dataType: "json",
      success: function (e) {
        setTimeout(function () {
          location = window.Shopify.routes.root + "cart";
        }, 1000);
      },
      error: function (e) {
        $(".cross-sell-content .notification .title").text(e.responseJSON.message);
        $(".cross-sell-content .notification .subtitle").text(e.responseJSON.description);

        setTimeout(function () {
          location = window.Shopify.routes.root + "cart";
        }, 1000);
      },
    });
  });
});
